<template>
  <div class="writes-nav">
    <b-navbar toggleable="lg" :variant="isGreenTheme ? 'writes-green' : 'writes'" :type="isGreenTheme ? 'dark' : 'light'">
      <b-navbar-brand href="/">
<!--        <img :src="require('@/assets/img/nav/logo.png')" alt="logo">-->
        <Icon name="Logo" width="170"></Icon>
      </b-navbar-brand>

      <!-- 漢堡按鈕（自己控制） -->
      <b-navbar-toggle target="sidebar" />

      <!-- 桌機版選單 -->
      <b-collapse is-nav>
        <b-navbar-nav class="nav-gap align-items-center ml-auto">
          <template v-if="!isLoggedIn">
            <b-nav-item @click="toAbout">關於</b-nav-item>
            <b-nav-item @click="toFeatures">服務特色</b-nav-item>
            <b-nav-item @click="toSaveHandwriting">保存手寫字</b-nav-item>
          </template>
          <template v-else>
            <b-nav-item @click="toMainDashboard">管理字跡</b-nav-item>
          </template>
          <b-nav-item href="https://www.pinkoi.com/store/writes" target="_blank">手寫字商店</b-nav-item>
          <b-nav-item-dropdown right v-if="isLoggedIn">
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <div class="avatar size-24px" v-if="user.MemberProfilePic">
                <img :src="user.MemberProfilePic" alt="avatar">
              </div>
              <Icon name="Initial_avatar" width="24" v-else></Icon>
              <Icon name="chevron-down" width="24"></Icon>
            </template>
            <b-dropdown-item @click="toMember">會員中心</b-dropdown-item>
            <b-dropdown-item @click="toHelp">說明中心</b-dropdown-item>
            <b-dropdown-item @click="logoutClicked">登出</b-dropdown-item>
          </b-nav-item-dropdown>

          <li class="nav-item" v-else>
            <router-link :to="{name:'Login'}" class="nav-link">
              <b-button variant="writes" size="lg">登入</b-button>
            </router-link>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- 右側滑出 Sidebar -->
    <b-sidebar
        id="sidebar"
        right
        shadow
        backdrop
    >
      <b-nav class="option-list fs-16px fw-semi-bold" vertical>
        <div class="d-flex flex-column">
          <b-nav-item @click="toMainDashboard">保存手寫字</b-nav-item>
          <b-nav-item>手寫字商店</b-nav-item>
          <template v-if="isLoggedIn">
            <b-nav-item @click="toMember">會員中心</b-nav-item>
            <b-nav-item>說明中心</b-nav-item>
          </template>
          <template v-else>
            <b-nav-item @click="toLogin">登入</b-nav-item>
          </template>
        </div>
        <div class="d-flex flex-column" v-if="isLoggedIn">
          <b-nav-item class="color-warning" @click="logoutClicked">登出</b-nav-item>
        </div>
      </b-nav>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { isNavigationFailure } from 'vue-router';

export default {
  name: 'TopNav',
  data() {
    return {
    };
  },
  props: {

  },
  components: {
  },
  computed: {
    ...mapGetters(['isStoreBusy', 'isMobileSize']),
    ...mapGetters('auth', ['hasToken']),
    ...mapState(['hideNav']),
    ...mapState('auth', ['user']),
    isLoggedIn() {
      return this.hasToken;
    },
    isGreenTheme() {
      const greenThemeRoutes = [
        'HelpCenter',
        // 'CampaignPage',  <-- 未來有其他頁面想變綠色，直接加在這邊即可
        // 'FaqPage'
      ];
      return greenThemeRoutes.includes(this.$route.name);
    }
  },
  watch: {
    $route() {
      // for (let i=0;i<this.links.length;i++) {
      //   this.links[i].show = false;
      //   this.showMenu = false;
      // }
    },
  },
  methods: {
    logoutClicked() {
      this.$store.dispatch('auth/logout');
      // this.$router.push({name: 'Login'});
      this.$router.push({name: 'Home'}).catch(err => {
        if (!isNavigationFailure(err)) {
          console.error(err) // 只有非導航失敗的錯誤才會顯示
        }
      });
    },
    toLogin() {
      if (this.$route.name === 'Login') return
      this.$router.push({ name: 'Login' });
    },
    toMember() {
      if (this.$route.name === 'MemberCenter') return
      this.$router.push({ name: 'MemberCenter' });
    },
    toHelp() {
      if (this.$route.name === 'HelpCenter') return
      this.$router.push({ name: 'HelpCenter' });
    },
    toMainDashboard() {
      if (this.$route.name === 'MainDashboard') return
      this.$router.push({ name: 'MainDashboard' });
    },
    toAbout() {
      if (this.$route.name === 'About') return
      this.$router.push({ name: 'About' });
    },
    toFeatures() {
      if (this.$route.name === 'Features') return
      this.$router.push({ name: 'Features' });
    },
    toSaveHandwriting() {
      if (this.$route.name === 'SaveHandwriting') return
      this.$router.push({ name: 'SaveHandwriting' });
    },
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
.writes-nav {
  nav.navbar-light.bg-writes, nav.navbar-dark.bg-writes-green {
    padding: 1.5rem 3rem;
    height: 96px;
    position: relative;
    @include smaller-than-large {
      // 與 App .padding-nav（72px）對齊，避免 375×667 內容鑽進 nav 破版
      padding: .75rem 1.5rem;
      height: 72px;
    }
    .navbar-brand {
      padding: 0;
      >img {
        // width: 12rem;
        height: 100%;
        max-height: 46px;
      }
    }

    .nav-gap {
      gap: 2rem;
    }

    .nav-item .nav-link {
      padding: 0;
    }

    .btn.btn-writes {
      min-width: 112px;
      background-color: $color-primary;
      color: #fff;
    }

    .btn.btn-outline-writes {
      border-color: $color-main-green;
      color: $color-main-green;
    }
  }
  nav.navbar-light.bg-writes {
    color: $color-primary;
    background: $color-white;
  }
  nav.navbar-dark.bg-writes-green {
    color: $color-white;
    background: $color-main-green;
  }
  .option-list {
    justify-content: space-between;
    height: 100%;
    .nav-item {
      border-bottom: .5px solid $color-border;
    }
    a.nav-link {
      color: $color-primary;
      padding: 1rem 1.25rem;
    }
    .color-warning {
      a.nav-link {
        color: $color-warning;
      }
    }
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/main.scss";
.writes-nav {
  nav.navbar-light.bg-writes {
    .navbar-nav .nav-link {
      color: $color-primary;
    }
  }
  nav.navbar-dark.bg-writes-green {
    .navbar-nav .nav-link {
      color: $color-white;
    }
  }
  .dropdown-toggle.nav-link {
    display: flex;
    align-items: center;
    gap: .375rem;
    &::after {
      display: none;
    }
  }
}
.b-sidebar-backdrop.bg-dark {
  background: #000000!important;
}
</style>
